import React from 'react';

import PropTypes from 'prop-types';

import ValueItem from 'components/Widgets/Profile/ValueItem';

export default function Age({ member }) {
  return (

    <ValueItem
      icon="age-icon"
      label="Your Age"
    >
      {member.age && `${member.age} years old`}
    </ValueItem>

  );
}

Age.propTypes = {
  member: PropTypes.object.isRequired,
};
